<template>
  <div class="addcomment" v-if="seen" @click="close">
    <div class="commentbox">
      <div class="comment-header">
        <div class="filename">
          <h3>Comment</h3>
          <p>{{ str_text(name) }}</p>
        </div>
        <div class="close_advanced_search" @click="close">
          <img src="@/assets/search-icons/Close.svg" />
        </div>
      </div>
      <div class="comments px-4">
        <div class="loader" v-if="loader">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid"
            viewBox="0 0 100 100"
            width="40px"
            height="40px"
            class="lds-dual-ring"
            style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%"
          >
            <circle
              cx="50"
              cy="50"
              fill="none"
              stroke-linecap="round"
              stroke="#039aed"
              r="30"
              stroke-dasharray="41.41592653589793 41.41592653589793"
              stroke-width="8"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                calcMode="linear"
                values="0 50 50;360 50 50"
                keyTimes="0;1"
                dur="1s"
                begin="0s"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
          </svg>
          <span> Loading previous comments... </span>
        </div>
        <div
          class="no-comment"
          v-if="!loader && $store.getters.COMMENTS.length === 0"
        >
          <span>No comment(s) found</span>
        </div>
        <div
          class="comment-text"
          v-if="!loader && $store.getters.COMMENTS.length"
        >
          <div
            class="body"
            v-for="(comment, index) in $store.getters.COMMENTS"
            :key="index"
          >
            <div class="profile-pix">
              <img :src="getPhoto(comment.img)" v-if="comment.img" />
              <span class="profile-initials" v-else>
                {{ getInitials(comment.name) }}
              </span>
            </div>
            <div class="text">
              <div class="top">
                <div class="name">
                  {{ comment.name }}
                </div>
                <div class="comment">
                  <pre>{{ comment.comment }}</pre>
                </div>
              </div>
              <div class="footer">
                <template v-if="$store.getters.USER == comment.user_id">
                  <span @click="edit(comment)">Edit</span
                  >&nbsp;&nbsp;&nbsp;<span
                    @click="delete_edit(comment)"
                    class="delete-comment"
                    >Delete</span
                  ><span class="date">{{ timeAgo(comment.createdAt) }}</span>
                </template>
                <template v-if="$store.getters.USER != comment.user_id">
                  <span @click="reply(comment)">Reply</span
                  ><span class="date">{{ timeAgo(comment.createdAt) }}</span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="more">
        <span class="more-comments" v-if="hasMore" @click="more_comments"
          >More comments...</span
        >
      </div>
      <div class="box">
        <div class="top">
          <div class="textfield">
            <div
              class="comment"
              id="contentEditableElementId"
              :class="{ error: error }"
              ref="comment"
              @input="test"
              contenteditable="true"
              placeholder="Write your comment"
              @focus="fint"
            ></div>
            <div class="send" @click="sendcomment">
              <svg
                style="width: 24px; height: 24px"
                viewBox="0 0 24 24"
                class="sendmsg"
              >
                <path fill="#3F96D1" d="M2,21L23,12L2,3V10L17,12L2,14V21Z" />
              </svg>
            </div>
          </div>
          <span class="cancel" @click="cancel" v-if="cancelbtn">Cancel</span>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.name {
  text-align: left;
}

.close_advanced_search {
  background: #f2f7fc;
  display: inline-flex;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: 15px;
}
.profile-initials {
  background-color: rgba(226, 232, 240, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  border-radius: 100%;
  font-size: 1.125rem;
  color: rgba(113, 128, 150, 1);
}
</style>

<script>
import { setTimeout } from "timers";
import { mapMutations, mapState } from "vuex";
import cookies from "@/services/cookies";
import moment from "moment";

export default {
  data() {
    return {
      seen: false,
      name: "",
      id: "",
      comment: "",
      error: false,
      loader: false,
      success: false,
      fint_text: true,
      base: false,
      cancelbtn: false,
      edit_id: "",
      hasMore: false,
    };
  },
  computed: {
    ...mapState(["backendUrl"]),
  },
  methods: {
    ...mapMutations([
      "UPDATE_PREVIEW_COMMENT",
      "UPDATE_TOTAL_COMMENT",
      "UPDATE_COMMENTS",
      "UPDATE_COMMENTS_LIST",
      "EMPTY_FILE_ACTION",
    ]),
    getPhoto(photo) {
      const pt = `${this.backendUrl}/static-photos/${photo}`;
      return pt;
    },
    getInitials(name) {
      const nm = name;
      return nm.charAt(0);
    },
    timeAgo(time) {
      return moment(time).fromNow(); // 8 years ago
    },
    fint(evt) {
      this.error = false;
    },
    str_text(str) {
      return str.length > 38 ? str.substr(0, 38) + "..." : str;
    },
    logincall() {
      this.$parent.logincall();
    },
    edit(comment) {
      this.cancelbtn = true;
      this.edit_id = comment._id;
      this.$refs.comment.innerText = comment.comment;
      // let p = document.getElementById('contentEditableElementId'),
      // s = window.getSelection(),
      // r = document.createRange();
      // r.setStart(p, 0);
      // r.setEnd(p, 0);
      // s.removeAllRanges();
      // s.addRange(r);
      // this.$refs.comment.focus()
    },
    test(evt) {
      if (evt.target.innerText == "") {
        // this.cancelbtn = false
      }
    },
    delete_edit(comment) {},
    reply(comment) {},
    cancel() {
      this.cancelbtn = false;
      this.$refs.comment.innerText = "";
      this.edit_id = "";
    },
    more_comments() {
      let data = {
        token: cookies.getCookie("token"),
        id: this.id,
        limit: false,
      };

      let that = this;

      this.$socket.emit("get-comments", data, function (data) {
        // console.log(data)
        if (data.data === true) {
          that.loader = false;
          that.hasMore = false;
          that.UPDATE_COMMENTS(data.comments);
        }

        if (data.data === false) {
          that.seen = false;
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    load(name, id, base = false) {
      this.loader = false;
      this.id = id;
      this.name = name;
      this.seen = true;
      this.base = base;

      if (this.id != "") {
        let that = this;
        this.loader = true;
        let data = {
          token: cookies.getCookie("token"),
          id: this.id,
          limit: true,
        };

        this.$socket.emit("get-comments", data, function (data) {
          // console.log(data)
          if (data.data === true) {
            that.loader = false;
            that.hasMore = data.total_comments > data.comments.length;
            that.UPDATE_COMMENTS(data.comments);
          }

          if (data.data === false) {
            that.seen = false;
            that.logincall();
            that.$router.push('/login')
          }
        });
      }
    },
    sendcomment() {
      if (this.$refs.comment.innerText === "") {
        this.error = true;
      } else {
        this.loader = true;
        let that = this;

        let data = {
          token: cookies.getCookie("token"),
          id: this.id,
          comment: this.$refs.comment.innerText,
          limit: true,
        };

        this.$socket.emit("addcomment", data, function (data) {
          if (data.message === "completed") {
            that.$refs.comment.innerText = "";
            that.loader = false;
            that.success = true;
            that.comment = "";
            that.UPDATE_COMMENTS_LIST(data.comments[0]);
            that.UPDATE_PREVIEW_COMMENT(data.comments);
            that.UPDATE_TOTAL_COMMENT(data.comments_total);

            if (that.base === true) {
              let index =
                that.$store.getters.GET_FILES_INDEX[
                  that.$store.getters.GET_FILE_ACTION[0]
                ];
              // let name = that.$store.getters.DIRECTORY_CHILDREN[index].is_checked = false

              that.EMPTY_FILE_ACTION();
            }

            setTimeout(() => {
              that.success = false;
            }, 3000);
          }

          if (data.data === false) {
            that.seen = false;
            that.logincall();
            that.$router.push('/login')
          }
        });
      }
    },
    close(evt) {
      if (
        evt.target.className == "close_advanced_search" ||
        evt.target.className == ""
      ) {
        this.seen = false;
        this.comment = "";
        this.loader = false;
      }

      if (evt.target.className == "addcomment") {
        this.seen = false;
        this.comment = "";
        this.loader = false;
      }
    },
  },
};
</script>
